import { create } from "zustand";

type ChatTimerState = {
  isGenerating: boolean;
  startTime: number | null;
  elapsedTime: number;
  startGeneration: () => void;
  stopGeneration: () => void;
  updateElapsedTime: () => void;
};

export const useChatTimerStore = create<ChatTimerState>((set, get) => ({
  isGenerating: false,
  startTime: null,
  elapsedTime: 0,

  startGeneration: () => {
    set({
      isGenerating: true,
      startTime: Date.now(),
      elapsedTime: 0,
    });
  },

  stopGeneration: () => {
    set({
      isGenerating: false,
      startTime: null,
    });
  },

  updateElapsedTime: () => {
    const { startTime, isGenerating } = get();
    if (isGenerating && startTime) {
      set({ elapsedTime: Date.now() - startTime });
    }
  },
}));
